/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespPromoModuleSecondaryOld_componentModule = {
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly imageCopy: string | null;
        readonly imageUrl?: string | null;
        readonly imageHeight?: string | null;
        readonly imageWidth?: string | null;
        readonly mobileImageUrl?: string | null;
        readonly mobileImageHeight?: string | null;
        readonly mobileImageWidth?: string | null;
        readonly cta: string | null;
        readonly linkData: {
            readonly path: string | null;
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
        readonly isFullBleedImage: boolean | null;
    } | null> | null;
    readonly " $refType": "HpRespPromoModuleSecondaryOld_componentModule";
};
export type HpRespPromoModuleSecondaryOld_componentModule$data = HpRespPromoModuleSecondaryOld_componentModule;
export type HpRespPromoModuleSecondaryOld_componentModule$key = {
    readonly " $data"?: HpRespPromoModuleSecondaryOld_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModuleSecondaryOld_componentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespPromoModuleSecondaryOld_componentModule",
  "type": "PromoModule",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "PromoItem",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cmsId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageCopy",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cta",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkData",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "path",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData",
              "args": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isFullBleedImage",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "Condition",
          "passingValue": false,
          "condition": "isMobile",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageHeight",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageWidth",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "isMobile",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageHeight",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageWidth",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '774945b5909d34479751c09756941fd1';
export default node;
